import ContactsListItem from './ContactsListItem';

export default ContactsListItem;
